export default "__VITE_ASSET__BM_4DK9X__"